import { useEffect } from "react";

const useAbortedEffect = (effect, dependencies) => {
  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const cleanupEffect = effect?.(signal);

    return () => {
      if (cleanupEffect) {
        cleanupEffect();
      }
      abortController.abort();
    };
    // Custom hook delegates dependency ownership to the caller.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useAbortedEffect;
